import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  image: {
    img: {
      objectFit: 'contain !important',
    },
    maxWidth: '100% !important',
  },
};